import { useScrollReveal } from '../../../hooks/useScrollReveal';

const ContactInfo = () => {
  const { ref: leftCardRef, isVisible: leftCardVisible } = useScrollReveal();
  const { ref: rightCardRef, isVisible: rightCardVisible } = useScrollReveal();
  const { ref: mapRef, isVisible: mapVisible } = useScrollReveal();

  return (
    <div className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Bilimsel Sekreterya */}
          <div 
            ref={leftCardRef}
            className={`bg-white rounded-2xl shadow-xl p-10 border border-gray-100 hover:shadow-2xl transition-all duration-300 ${
              leftCardVisible ? 'animate-slide-left' : 'opacity-0'
            }`}
          >
            <div className="flex items-center space-x-4 mb-8">
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-[#0D1B3E] to-[#1A2B5E] rounded-xl">
                <i className="ri-building-line text-3xl text-white"></i>
              </div>
              <div>
                <h2 className="text-2xl font-bold text-[#0D1B3E]">Bilimsel Sekreterya</h2>
                <p className="text-sm text-gray-500">Genç Diş Hekimliği Derneği</p>
              </div>
            </div>

            <div className="space-y-6">
              <div className={`flex items-start space-x-4 group ${leftCardVisible ? 'animate-fade-in animate-stagger-1' : 'opacity-0'}`}>
                <div className="w-12 h-12 flex items-center justify-center bg-[#1A9B8C]/10 rounded-lg group-hover:bg-[#1A9B8C]/20 transition-colors">
                  <i className="ri-map-pin-line text-2xl text-[#1A9B8C]"></i>
                </div>
                <div className="flex-1">
                  <div className="text-sm font-semibold text-gray-700 mb-1">Adres</div>
                  <div className="text-gray-600 leading-relaxed">
                    Meşrutiyet Mahallesi, Karanfil Sokak,<br />
                    Uslu İş Hanı No: 16/59<br />
                    Çankaya/Ankara
                  </div>
                </div>
              </div>

              <div className={`flex items-start space-x-4 group ${leftCardVisible ? 'animate-fade-in animate-stagger-2' : 'opacity-0'}`}>
                <div className="w-12 h-12 flex items-center justify-center bg-[#1A9B8C]/10 rounded-lg group-hover:bg-[#1A9B8C]/20 transition-colors">
                  <i className="ri-phone-line text-2xl text-[#1A9B8C]"></i>
                </div>
                <div className="flex-1">
                  <div className="text-sm font-semibold text-gray-700 mb-1">GSM</div>
                  <a href="tel:+905423313792" className="text-gray-600 hover:text-[#1A9B8C] transition-colors cursor-pointer">
                    0542 331 37 92
                  </a>
                </div>
              </div>

              <div className={`flex items-start space-x-4 group ${leftCardVisible ? 'animate-fade-in animate-stagger-3' : 'opacity-0'}`}>
                <div className="w-12 h-12 flex items-center justify-center bg-[#1A9B8C]/10 rounded-lg group-hover:bg-[#1A9B8C]/20 transition-colors">
                  <i className="ri-mail-line text-2xl text-[#1A9B8C]"></i>
                </div>
                <div className="flex-1">
                  <div className="text-sm font-semibold text-gray-700 mb-1">Mail</div>
                  <a href="mailto:treasurer@gdhder.org.tr" className="text-gray-600 hover:text-[#1A9B8C] transition-colors cursor-pointer break-all">
                    treasurer@gdhder.org.tr
                  </a>
                </div>
              </div>

              <div className={`flex items-start space-x-4 group ${leftCardVisible ? 'animate-fade-in animate-stagger-4' : 'opacity-0'}`}>
                <div className="w-12 h-12 flex items-center justify-center bg-[#1A9B8C]/10 rounded-lg group-hover:bg-[#1A9B8C]/20 transition-colors">
                  <i className="ri-global-line text-2xl text-[#1A9B8C]"></i>
                </div>
                <div className="flex-1">
                  <div className="text-sm font-semibold text-gray-700 mb-1">Web</div>
                  <a href="https://www.gdhder.org.tr" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-[#1A9B8C] transition-colors cursor-pointer">
                    www.gdhder.org.tr
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Organizasyon Sekreteryası */}
          <div 
            ref={rightCardRef}
            className={`bg-white rounded-2xl shadow-xl p-10 border border-gray-100 hover:shadow-2xl transition-all duration-300 ${
              rightCardVisible ? 'animate-slide-right' : 'opacity-0'
            }`}
          >
            <div className="flex items-center space-x-4 mb-8">
              <div className="w-16 h-16 flex items-center justify-center bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden p-1">
                <img
                  src="https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/3a04ac56c91b80d40292b577e71348c9.png"
                  alt="IDENTA Event & Organizasyon Logo"
                  className="w-full h-full object-contain"
                />
              </div>
              <div>
                <h2 className="text-2xl font-bold text-[#0D1B3E]">Organizasyon Sekreteryası</h2>
                <p className="text-sm text-gray-500">IDENTA Event &amp; Organizasyon</p>
              </div>
            </div>

            <div className="space-y-6">
              <div className={`flex items-start space-x-4 group ${rightCardVisible ? 'animate-fade-in animate-stagger-1' : 'opacity-0'}`}>
                <div className="w-12 h-12 flex items-center justify-center bg-[#0D1B3E]/10 rounded-lg group-hover:bg-[#0D1B3E]/20 transition-colors">
                  <i className="ri-map-pin-line text-2xl text-[#0D1B3E]"></i>
                </div>
                <div className="flex-1">
                  <div className="text-sm font-semibold text-gray-700 mb-1">Adres</div>
                  <div className="text-gray-600 leading-relaxed">
                    Yıldızevler Mah. Turan Güneş Blv.<br />
                    Özaltın Apt. No: 52 İç Kapı No: 1<br />
                    Çankaya/Ankara
                  </div>
                </div>
              </div>

              <div className={`flex items-start space-x-4 group ${rightCardVisible ? 'animate-fade-in animate-stagger-2' : 'opacity-0'}`}>
                <div className="w-12 h-12 flex items-center justify-center bg-[#0D1B3E]/10 rounded-lg group-hover:bg-[#0D1B3E]/20 transition-colors">
                  <i className="ri-phone-line text-2xl text-[#0D1B3E]"></i>
                </div>
                <div className="flex-1">
                  <div className="text-sm font-semibold text-gray-700 mb-1">GSM</div>
                  <a href="tel:+905350670675" className="text-gray-600 hover:text-[#0D1B3E] transition-colors cursor-pointer">
                    +90 535 067 06 75
                  </a>
                </div>
              </div>

              <div className={`flex items-start space-x-4 group ${rightCardVisible ? 'animate-fade-in animate-stagger-3' : 'opacity-0'}`}>
                <div className="w-12 h-12 flex items-center justify-center bg-[#0D1B3E]/10 rounded-lg group-hover:bg-[#0D1B3E]/20 transition-colors">
                  <i className="ri-mail-line text-2xl text-[#0D1B3E]"></i>
                </div>
                <div className="flex-1">
                  <div className="text-sm font-semibold text-gray-700 mb-1">E-mail</div>
                  <a href="mailto:serkan@identaevent.com" className="text-gray-600 hover:text-[#0D1B3E] transition-colors cursor-pointer break-all">
                    serkan@identaevent.com
                  </a>
                </div>
              </div>

              <div className={`bg-gradient-to-br from-[#0D1B3E]/5 to-[#1A9B8C]/5 rounded-xl p-6 mt-8 ${rightCardVisible ? 'animate-fade-in animate-stagger-4' : 'opacity-0'}`}>
                <div className="flex items-start space-x-3">
                  <i className="ri-information-line text-2xl text-[#0D1B3E] mt-1"></i>
                  <div>
                    <div className="font-semibold text-[#0D1B3E] mb-2">Organizasyon Hizmetleri</div>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      Kongre kayıt, konaklama, ulaşım ve özel organizasyon talepleri için organizasyon sekreteryamız ile iletişime geçebilirsiniz.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Harita Bölümü */}
        <div 
          ref={mapRef}
          className={`mt-16 bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100 ${
            mapVisible ? 'animate-scale-in' : 'opacity-0'
          }`}
        >
          <div className="p-8 bg-gradient-to-r from-[#0D1B3E] to-[#1A2B5E] text-white">
            <div className="flex items-center space-x-3">
              <i className="ri-map-2-line text-3xl text-[#C9A84C]"></i>
              <div>
                <h3 className="text-2xl font-bold">Kongre Merkezi Konumu</h3>
                <p className="text-white/80 text-sm mt-1">İstanbul Kongre Merkezi - İstanbul</p>
              </div>
            </div>
          </div>
          <div className="relative h-[500px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3009.4!2d28.9784!3d41.0082!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab9bd6570f4e1%3A0x8e0d8e0d8e0d8e0d!2zxLBzdGFuYnVsIEtvbmdyZSBNZXJrZXpp!5e0!3m2!1str!2str!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Kongre Merkezi Konumu"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;